export class ExpectedStripeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ExpectedStripeError";
  }
}
